// ======================================================================
// File Name       : reservedEmail.js
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import moment from 'moment';
import * as ActionTypes from '../constants/actionTypes/email';
import store from '../store';

const initialState = {
  filterData: {
    reservedEmailTitle: null,
    reservedEmailDateFrom: null,
    reservedEmailDateTo: null,
    reservedEmailSortType: null,
    ascendingDescendingSort: null,
    startPosition: 0,
  },
  recordNum: 0,
  reservedEmailList: [],
};

export default function reservedEmail(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.GET_RESERVED_EMAIL_LIST:
      return getReservedEmailList(state, action);

    case ActionTypes.GET_RESERVED_EMAIL_EDIT:
      return getReservedEmailEdit(state, action);

    case ActionTypes.GET_RESERVED_EMAIL_DETAIL:
      return getReservedMailDetail(state, action);

    default: {
      const { filterData } = initialState;
      return {
        ...state,
        filterData,
      };
    }
  }
}

function getReservedEmailList(state, action) {
  const { resData } = action;
  const { recordNum } = resData;
  const reservedEmailList = resData.reservedEmailList;

  return {
    ...state,
    reservedEmailList,
    recordNum,
  };
}

function getReservedMailDetail(state, action) {
  const { emailSenderIdAuto } = action;
  const reservedEmailList = [...state.reservedEmailList];
  let reservedEmailInfo = {};

  if (reservedEmailList && reservedEmailList.length) {
    for (let i = 0; i < reservedEmailList.length; i++) {
      if (reservedEmailList[i].emailSenderIdAuto === emailSenderIdAuto) {
        reservedEmailInfo = reservedEmailList[i];
        break;
      }
    }
  }
  return {
    ...state,
    reservedEmailInfo,
  };
}

function getReservedEmailEdit(state, action) {
  const { resData } = action;
  const { reservedEmailList } = resData;

  let reservedEmailDetail = {};
  if (reservedEmailList && reservedEmailList.length) {
    reservedEmailDetail = reservedEmailList[0];
  }

  const formInitialValues = { ...reservedEmailDetail };
  formInitialValues.reservedDate = moment(formInitialValues.reservedDate);
  formInitialValues.emailTitle = formInitialValues.reservedEmailTitle;
  formInitialValues.emailContents = formInitialValues.reservedEmailContents;
  formInitialValues.emailReplyTo = formInitialValues.reservedEmailReplyTo;

  const editingUser = {
    bySecernId: {},
    allSecernIds: [],
  };

  formInitialValues.emailReceiverList = editingUser; // Reset value
  const email = store.getState().email;
  if (email && email.editingUser) {
    formInitialValues.emailReceiverList = email.editingUser;
  }

  return {
    ...state,
    formInitialValues,
  };
}
